module.exports = __webpack_public_path__ + "img/policia_ministerial_up.50480a8f.svg";